<template>
  <div class="home"  v-if="!this.$store.state.isMobile">
    <carousel-p></carousel-p>
      <carousel-m></carousel-m>
    <card-p></card-p>
      <card-m></card-m>

    <div id="ICP">
<!--      <el-divider></el-divider>-->
      <el-link href="http://beian.miit.gov.cn/" type="info">粤ICP备2021040975号</el-link>
    </div>
  </div>
</template>

<script>
  import CarouselP from "../components/carousel/CarouselP";
  import CarouselM from "../components/carousel/CarouselM";
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
  import CardP from "../components/card/CardP";
import CardM from "../components/card/CardM";
//import {rem} from "../assets/js/rem";

export default {
  name: 'Home',
  components: {
    HelloWorld,
    CarouselP,
      CarouselM,
    CardP,
      CardM,
  },
  mounted() {

  }
}
</script>
<style scoped>
  .home{
      background-color: #F8F8F8;
  }
  #ICP{
    position: absolute;

    width: 100%;
    /*background-color: red;*/
    margin-bottom: 0px;
    /*left: 50%;*/
    text-align: center;
  }
  #ICP a{
    border-top-style: solid;
    margin-top: 10px;
    padding-top: 10px;
    /*border-top: #8c939d;*/
    width: 100%;
    height: 100%;
    background-color: #F0F0F0;
  }
</style>